module.exports = __webpack_public_path__ + "static/media/Dart_logo.d1548197.png";